/**
 * LLM providers for test generation.
 *
 * Generation is the one place an LLM is allowed. Execution never is — the run
 * path stays heuristic and deterministic, which is what the product sells.
 *
 * Two ways to supply a model, in precedence order:
 *
 *  - **BYOK.** The caller's own key arrives per request and is used for that
 *    request only. It is never persisted, never logged, never written to
 *    settings. This is what an enterprise compliance review asks for, so it is
 *    the default when a key is present.
 *  - **Hosted.** When the caller has no key, the server uses the operator's
 *    configured provider. The operator supplies it through the super-admin menu;
 *    a customer never sees or controls it.
 *
 * BYOK wins whenever a key is supplied. An operator cannot silently spend
 * their own credits on a customer who brought their own key.
 */
export const LLM_MODELS = {
    anthropic: [
        { value: 'claude-3-5-sonnet-20241022', label: 'Claude 3.5 Sonnet (Recommended)' },
        { value: 'claude-3-5-haiku-latest', label: 'Claude 3.5 Haiku (Fast & Cheap)' },
        { value: 'claude-3-opus-20240229', label: 'Claude 3 Opus (Deep Reasoning)' },
        { value: 'claude-3-sonnet-20240229', label: 'Claude 3 Sonnet (Legacy)' },
    ],
    openai: [
        { value: 'gpt-4o-mini', label: 'GPT-4o Mini (Recommended / Fast)' },
        { value: 'gpt-4o', label: 'GPT-4o (Flagship Multimodal)' },
        { value: 'o1-mini', label: 'o1 Mini (Reasoning)' },
        { value: 'o1-preview', label: 'o1 Preview (Deep Reasoning)' },
        { value: 'gpt-4-turbo', label: 'GPT-4 Turbo' },
        { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' },
    ],
    google: [
        { value: 'gemini-1.5-flash-latest', label: 'Gemini 1.5 Flash (Recommended / Fast)' },
        { value: 'gemini-1.5-pro-latest', label: 'Gemini 1.5 Pro (High Context)' },
        { value: 'gemini-2.0-flash-exp', label: 'Gemini 2.0 Flash (Next-gen)' },
    ],
    custom: [
        { value: 'llama-3.3-70b-versatile', label: 'Llama 3.3 70B Versatile' },
        { value: 'llama-3.1-8b-instant', label: 'Llama 3.1 8B Instant (Fast)' },
        { value: 'mistral-large-latest', label: 'Mistral Large' },
        { value: 'deepseek-chat', label: 'DeepSeek Chat (V3)' },
        { value: 'deepseek-reasoner', label: 'DeepSeek Reasoner (R1)' },
        { value: 'qwen-2.5-72b-instruct', label: 'Qwen 2.5 72B' },
    ],
};
//# sourceMappingURL=generation.js.map